import { render, staticRenderFns } from "./Employee_details.vue?vue&type=template&id=09a37c3c&scoped=true"
import script from "./Employee_details.vue?vue&type=script&lang=js"
export * from "./Employee_details.vue?vue&type=script&lang=js"
import style0 from "./Employee_details.vue?vue&type=style&index=0&id=09a37c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a37c3c",
  null
  
)

export default component.exports